// web/src/components/common/HeaderAuth.jsx
import React, { useEffect, useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { Link, useLocation } from "react-router-dom";

export default function HeaderAuth({
  onOpenLogin,
  onOpenSignup,
  floating = false,
  top = 12,
  right = 12,
}) {
  const { user, logout } = useAuth();
  const [quota, setQuota] = useState(null);
  const loc = useLocation();

  // 🚫 HARD KILL for screenshots: if guest on /results/*, don't render at all.
  // Headless PDF is always a guest → header never exists → can't overlap screenshots.
  const onResults = typeof loc?.pathname === "string" && loc.pathname.startsWith("/results/");
  const fetchQuota = async () => {
    if (!user) { setQuota(null); return; }
    try {
      const r = await fetch("/api/me/quota", { credentials: "include" });
      if (r.ok) setQuota(await r.json());
    } catch {}
  };

  useEffect(() => { fetchQuota(); }, [user, loc.pathname]);
  useEffect(() => {
    const onBump = () => fetchQuota();
    window.addEventListener("quota-changed", onBump);
    return () => window.removeEventListener("quota-changed", onBump);
  }, []);

  if (!user && onResults) return null;

  const left = quota?.reports_left ?? 0;

  const wrapStyle = floating
    ? { top, right, zIndex: 1000 }
    : { display: "inline-block" };

  return (
    <div
      className="header-auth"
      data-header-auth=""
      data-floating={floating ? "1" : "0"}
      style={wrapStyle}
      aria-label="Compte"
    >
      <div className="ha-chip" aria-live="polite">
        {!user ? (
          <>
            <button onClick={onOpenLogin}  className="btn btn-primary" title="Se connecter">Se connecter</button>
            <button onClick={onOpenSignup} className="btn btn-success" title="Créer un compte">Créer un compte</button>
          </>
        ) : (
          <>
            <span className="user-name" title={user?.name || user?.email}
                  style={{fontWeight:700,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>
              Bonjour, {user?.name || user?.email}
            </span>
            {/* <span className="credits-pill" title="Rapports restants">🧾 {left}</span> */}
            <Link to="/compte" className="btn btn-light" title="Mon compte">Mon compte</Link>
            <button onClick={logout} className="btn btn-danger" title="Se déconnecter">Déconnexion</button>
          </>
        )}
      </div>
    </div>
  );
}
